import Data from './Data';

const CardSidebar = (props) => {
  return <Data {...props} />;
};

export default CardSidebar;
